var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { initService as initProcessService } from "../../apis/process";
import authService from "../auth/authService";
let user;
export default {
    getTasks() {
        return __awaiter(this, arguments, void 0, function* (param = {}) {
            const userInfo = yield authService.getUserInfo();
            user = userInfo === null || userInfo === void 0 ? void 0 : userInfo.UserName;
            const { query } = param;
            const res = yield initProcessService().getTasks({
                query: Object.assign(Object.assign({}, query), { user }),
            });
            return res;
        });
    },
    claimTask() {
        return __awaiter(this, arguments, void 0, function* (param = {}) {
            const { path = {} } = param;
            const res = yield initProcessService().claimTask({
                path: Object.assign({}, path),
                body: {
                    user,
                },
            });
            return res;
        });
    },
    getDestinationUrl() {
        return __awaiter(this, arguments, void 0, function* (param = {}) {
            const { path: { id }, } = param;
            const res = yield initProcessService().getDestinationUrl({
                path: { id },
                query: {
                    user,
                },
            });
            return res;
        });
    },
};
